export const yellow = {
  100: 'var(--bfc-v2-color-yellow-100, #fef7c8)',
  200: 'var(--bfc-v2-color-yellow-200, #ffdf84)',
  300: 'var(--bfc-v2-color-yellow-300, #fed153)',
  400: 'var(--bfc-v2-color-yellow-400, #fbbf25)',
  500: 'var(--bfc-v2-color-yellow-500, #e5ad1d)',
  600: 'var(--bfc-v2-color-yellow-600, #c59109)',
  700: 'var(--bfc-v2-color-yellow-700, #977007)',
  800: 'var(--bfc-v2-color-yellow-800, #7f5f01)',
  900: 'var(--bfc-v2-color-yellow-900, #533f04)',
  1000: 'var(--bfc-v2-color-yellow-1000, #332e1b)',
  DEFAULT: 'var(--bfc-v2-color-yellow-700, #946f00)', // 700
};
